import React, { useEffect, useState } from "react";
import MainLayout from "components/layout/main-layout/MainLayout.js";
import { titles } from "constants/titles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getEsignHistoryList } from "redux/UserDetails/actions";
import "./AddReviewAndSign.css";
import CustomButton from "components/widgets/custom-button/CustomButton";

const AddReviewAndSign = () => {
  const { loading, eSignHistory } = useSelector((store) => store?.userDetail);
  const histroy = useHistory();
  const dispatch = useDispatch();
  const [selectedUrl, setSelectedUrl] = useState(null);
  const [showWebView, setShowWebView] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);

  useEffect(() => {
    getEsignHistoryList(dispatch, histroy);
  }, []);

  const renderSeviceList = (eSignList) => {
    return eSignList?.map((item, index) => {
      return (
        <div key={`service-${index}`} className="ars_card_container">
          <p className="ars_service_name">
            {item?.name}
          </p>
          <CustomButton
            text={titles?.see_details}
            className={'ars_see_details_btn'}
            onClick={() => handleSeeDetailsClick(item?.url)}
          >
          </CustomButton>
        </div>
      );
    });
  };

  const handleBackClick = () => {
    setShowWebView(false);
    setSelectedUrl(null);
    setIframeLoading(false);
  };

  const handleSeeDetailsClick = (url) => {
    setSelectedUrl(url);
    setShowWebView(true);
    setIframeLoading(true);
  };

  return (
    <MainLayout
      text={titles?.review_and_sign}
      isBackHide={false}
      isSemiHeader={true}
      isNavbar={true}
      isLoading={loading || iframeLoading}
      white={true}
      fullWidthScreen={showWebView}
      onBackClick={showWebView ? handleBackClick : undefined}
    >
      {/* Conditional iframe when iframe flow is active */}
      {showWebView ? (
        <div className="iframe_container">
          {selectedUrl ? (
            <iframe
              src={selectedUrl}
              frameBorder="0"
              title="Review and Sign"
              className="ars_iframe"
              onLoad={() => {
                setIframeLoading(false);
              }}
              onError={() => {
                setIframeLoading(false);
                console.error("Iframe loading error");
              }}
            />
          ) : null}
        </div>
      ) : (
        <div className="ars_main_container">
          {!loading ? (
            eSignHistory?.active_subscription_changes ||
            eSignHistory?.account_holder_info_changes ||
            eSignHistory?.sale_orders ? (
              <div>
                <div>
                  <h1 className="ars_approval_needed_text">{titles?.approval_needed}</h1>
                  <p className="ars_description_text">
                    {titles?.signature_needed_desc}
                  </p>
                </div>
                
                {eSignHistory?.active_subscription_changes?.length > 0 ? (
                  <div className="ars_section">
                    <h2 className="ars_section_title">
                      {titles?.active_subscription_changes}
                    </h2>
                    <div className="ars_cards_list">
                      {renderSeviceList(
                        eSignHistory?.active_subscription_changes || []
                      )}
                    </div>
                  </div>
                ) : null}

                {eSignHistory?.account_holder_info_changes?.length > 0 ? (
                  <div className="ars_section">
                    <h2 className="ars_section_title">
                      {titles?.account_holder_information_changes}
                    </h2>
                    <div className="ars_cards_list">
                      {renderSeviceList(
                        eSignHistory?.account_holder_info_changes || []
                      )}
                    </div>
                  </div>
                ) : null}

                {eSignHistory?.sale_orders?.length > 0 ? (
                  <div className="ars_section">
                    <h2 className="ars_section_title">
                      {titles?.new_orders}
                    </h2>
                    <div className="ars_cards_list">
                      {renderSeviceList(eSignHistory?.sale_orders || [])}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
                <p className="ars_empty_message">
                  No records require your approval
                </p>
            )
          ) : null}
        </div>
      )}
    </MainLayout>
  );
};

export default AddReviewAndSign;
